import React, {useState, useEffect} from 'react';
import {connect} from 'react-redux';
import {enToFa} from '../utils/NumberUtility';
import Slider from "react-slick";
import {yesNo} from '../utils/BooleanUtility';
import {Collapse} from 'reactstrap';
import ReactMapGL, {Marker} from 'react-map-gl';
import PerfectScrollbar from 'react-perfect-scrollbar';
import Loading from '../components/Loading';
import JobAdItem from '../components/JobAdItem';
import VehicleAdItem from '../components/VehicleAdItem';
import Pagination from '../components/Pagination';
import {startFetchGalleryAds, startFetchGalleryDetails} from '../actions/galleryDetailInfo';
import {nextPage, prevPage} from '../actions/galleryDetailFilters';
import logo from '../assets/images/C_logo.png';

const GalleryDetails = (props) => {

    const [isAdsLoading, setAdsLoading] = useState(true);
    const [isInfoLoading, setInfoLoading] = useState(true);
    const [isOpen, setOpen] = useState(false);

    const settings = {
        arrows: false,
        dots: true,
        infinite: true,
        rtl: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1
    };

    const detailKeys = [
      { key: "galleryTitle", translation: 'عنوان' },
      { key: "ownerTitle", translation: 'مالک' },
      { key: "company", translation: 'شرکت تولید کننده' },
      { key: "isSelling", translation: 'فروش دارد' },
      { key: "hasServices", translation: 'خدمات پس از فروش' },
      { key: "workingContext", translation: 'زمینه‌های کاری' },
      { key: "city", translation: 'محل آگهی' },
      { key: "phoneNo", translation: 'تلفن ثابت', template:'tel:VALUE' },
      { key: "verifiedPhoneNumber", translation: 'شماره همراه', template:'tel:VALUE' },
      { key: "faxNo", translation: 'فکس' },
      { key: "address", translation: 'آدرس' },
      { key: "email", translation: 'پست الکترونیکی', template:'mailto:VALUE' },
      { key: "instagramLink", translation: 'آدرس اینستاگرام', template:'https://www.instagram.com/VALUE' },
      { key: "description", translation: 'توضیحات' },
  ]

    useEffect(() => {
        if (isAdsLoading){
            props.startFetchGalleryAds(props.match.params.id)
            .then(({success, error}) => {
                if (success){
                    setAdsLoading(false)
                }
                else{
                    setAdsLoading(false)
                }
            })
        }
    }, [isAdsLoading])

    useEffect(() => {
        if (isInfoLoading){
            props.startFetchGalleryDetails(props.match.params.id)
            .then(({success, error}) => {
                if (success){
                    setInfoLoading(false)
                }
                else{
                    setInfoLoading(false)
                }
            })
        }
    }, [])

    const handleNext = () => {
        props.nextPage();
        setAdsLoading(true);
    }
    
    const handlePrev = () => {
        props.prevPage();
        setAdsLoading(true);
    }

    const onExpandClicked = (e) => {
        setOpen(!isOpen);
    }

    const detailValueRenderer = (key) => {
        if (props.info[key['key']]['title'])
            return <span className="vehicle-details__table-value col-6">{enToFa(props.info[key['key']]['title'])}</span>
        if (key['key'] == 'city')
            return <span className="vehicle-details__table-value col-6">{`${props.info[key['key']]['name']} ، ${props.info[key['key']]['state']['name']}`}</span>
        if (key['key'] == 'workingContext')
            return <span className="vehicle-details__table-value col-6">{props.info.workingContext.map(context => ` ${context.title}`).join('،')}</span>
        if (!(key['key'] == 'workingContext' || key['key'] == 'city' || props.info[key['key']]['title']) && !key['template'])
            return <span className="vehicle-details__table-value col-6">{enToFa(yesNo(props.info[key['key']]))}</span>
        else if (!(key['key'] == 'workingContext' || key['key'] == 'city' || props.info[key['key']]['title']) && key['template'])
            return <a className="vehicle-details__table-value about__contact-text col-6" href={key['template'].replace('VALUE', props.info[key['key']])}>{enToFa(yesNo(props.info[key['key']]))}</a>
    }

    const renderSlides = () => {
        const slides = props.info.images.length == 0 ? [logo] : props.info.images.map((item) => (item.image))
        // const slides = [logo, logo, logo];
        return slides.map((slide) => {
            return (
                <div className={props.info.images.length == 0 ? "carousel__slide--no-img" : "carousel__slide"}>
                    <img className={ props.info.images.length == 0 ? "carousel__slide-image--no-img" : "carousel__slide-image"} src={slide}/>
                </div>
            );
        });
    }
    
    return(
        <div className="container-sm optimized__d-flex-class flex-column h-100 px-0 ads">
        {
            (isAdsLoading || isInfoLoading) ? (
                <Loading/>
            ) : (
                <div className="store__head-container">
                    <Slider {...settings}>
                        {renderSlides()}
                    </Slider>
                    <div className="ads__drop-handle pr-4">
                        < img className = "vehicle-ad__img col-4 px-2"
                        src = {
                            props.info.logo || logo
                        }
                        />
                        <span onClick={onExpandClicked} className="optimized__d-flex-class align-items-center">اطلاعات بیشتر<i class="material-icons p-2">{isOpen ? "keyboard_arrow_up" : "keyboard_arrow_down"}</i></span>
                    </div>
                    <Collapse isOpen={isOpen}>
                        <div className="ads__drop-bg">
                            {detailKeys.map((el) => {
                                return props.info[el.key] ? (
                                    <>
                                        <span className="vehicle-details__table-key col-6">{`${el.translation}:`}</span>
                                        {detailValueRenderer(el)}
                                    </>
                                ) : undefined
                            })}
                            {false && props.info.lat && props.info.lng ? (
                                <ReactMapGL
                                    mapboxApiAccessToken="pk.eyJ1IjoiYXBwc3RhdGlzdGljaWFuIiwiYSI6ImNrYjF6bTh6ZzBjN2gyenBqOTd5dmJ0bDIifQ.b1MJuTbmP-biJSkEz-g8KA"
                                    mapStyle="mapbox://styles/mapbox/outdoors-v11"
                                    width="100%" height="40vh" latitude={+props.info.lat} longitude={+props.info.lng} zoom={12}
                                    >
                                        <Marker
                                            latitude={+props.info.lat}
                                            longitude={+props.info.lng}>
                                                <span><i className="material-icons">location_on</i></span>
                                        </Marker>
                                </ReactMapGL>
                            ): undefined}
                        </div>
                    </Collapse>
                    {/* <PerfectScrollbar id="vehicle-scroller" className="px-4"> */}
                        {
                            props.ads.map(el => el.identifier === "vehicle" ? (<VehicleAdItem for="vehicle-scroller" sharedElement key={el.id} info={el} push={props.history.push}/>) : (<JobAdItem for="vehicle-scroller" sharedElement key={el.id} info={el} push={props.history.push}/>))
                        }
                        <Pagination
                            currentPage={props.page}
                            pageCount={props.pageCount}
                            handleNext={handleNext}
                            handlePrev={handlePrev}
                        />
                    {/* </PerfectScrollbar> */}
                </div>
            )
        }
        </div>
    );
}

const mapStateToProps = (state, props) => ({
    page: state.galleryDetailFilters.page,
    pageCount: Math.ceil(state.galleryDetailInfo.total / state.galleryDetailFilters.page_size),
    ads: state.galleryDetailInfo.items,
    info: state.galleryDetailInfo.info
});

const mapDispatchToProps = (dispatch) => ({
    nextPage: () => dispatch(nextPage()),
    prevPage: () => dispatch(prevPage()),
    startFetchGalleryAds: (ident) => dispatch(startFetchGalleryAds(ident)),
    startFetchGalleryDetails: (ident) => dispatch(startFetchGalleryDetails(ident))
});

export default connect(mapStateToProps, mapDispatchToProps)(GalleryDetails);